"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMenuNoteMutationOptions = exports.updateMenuNoteMutation = void 0;
const client_1 = require("@apollo/client");
const menuPlanner_1 = require("../queries/menuPlanner");
exports.updateMenuNoteMutation = client_1.gql `
  mutation UpdateMenuNote($id: String!, $input: UpdateMenuNoteInput!) {
    updateMenuNote(id: $id, input: $input) {
      ok
    }
  }
`;
exports.updateMenuNoteMutationOptions = (variables, menuPlannerQueryVariables, toVariables, optimisticResponsePlz) => ({
    variables,
    optimisticResponse: !optimisticResponsePlz
        ? undefined
        : {
            __typename: "Mutation",
            updateMenuNote: {
                __typename: "OkResponse",
                ok: true,
            },
        },
    update: !menuPlannerQueryVariables
        ? undefined
        : (store, { data: dataResponse }) => {
            if (!dataResponse) {
                return;
            }
            const data = store.readQuery({
                query: menuPlanner_1.menuPlannerQuery,
                variables: menuPlannerQueryVariables,
            });
            let menuItemThatMoved = data &&
                data.menuPlanner.find(x => x.id === variables.id);
            if (data) {
                store.writeQuery({
                    query: menuPlanner_1.menuPlannerQuery,
                    variables: menuPlannerQueryVariables,
                    data: Object.assign(Object.assign({}, data), { menuPlanner: toVariables
                            ? data.menuPlanner.filter(x => x.id !== variables.id)
                            : data.menuPlanner.map(mi => mi.id === variables.id
                                ? Object.assign(Object.assign(Object.assign({}, mi), variables.input), { date: variables.input.date || mi.date, menuSectionId: variables.input.menuSectionId || mi.menuSectionId, text: variables.input.text ||
                                        ("text" in mi ? mi.text : "") }) : mi) }),
                });
            }
            if (toVariables) {
                let data2;
                try {
                    data2 = store.readQuery({
                        query: menuPlanner_1.menuPlannerQuery,
                        variables: toVariables,
                    });
                }
                catch (_a) { }
                if (data2 && menuItemThatMoved) {
                    store.writeQuery({
                        query: menuPlanner_1.menuPlannerQuery,
                        variables: toVariables,
                        data: Object.assign(Object.assign({ __typename: "Query" }, data), { menuPlanner: [
                                ...data2.menuPlanner,
                                Object.assign(Object.assign({}, menuItemThatMoved), { date: variables.input.date || menuItemThatMoved.date, menuSectionId: variables.input.menuSectionId ||
                                        menuItemThatMoved.menuSectionId }),
                            ] }),
                    });
                }
            }
        },
});
//# sourceMappingURL=updateMenuNote.js.map